import(/* webpackChunkName: "teaserImageText" */ '../../Styles/TeaserImageText/teaserImageText.scss');

await import(/* webpackChunkName: "jquery-match-height" */ 'jquery-match-height');

window.am = window.am || {};

window.am.teaserImageText = new function () {
    const that = this;

    that.init = function () {
        that.setEqualHeadlineHeight();
        that.setEqualHeight();

        window.addEventListener('resize', that.setEqualHeight);
        window.addEventListener('resize', that.setEqualHeadlineHeight);
        window.addEventListener('orientationchange', that.setEqualHeight);
        window.addEventListener('orientationchange', that.setEqualHeadlineHeight);
    };

    that.setEqualHeight = () => {
        $(document).find('.row').each(function () {
            // image is already loaded by lazy load
            $(this).find('.imageTextTeaser.imageTextTeaser--equal-height .lazyloaded')
                   .parent('.imageTextTeaser')
                   .matchHeight();

            // image will be loaded later by lazy load
            $(this).find('.imageTextTeaser.imageTextTeaser--equal-height .lazyload').on('load', () => {
                $(this).find('.imageTextTeaser').matchHeight();
            });

            // no image available 
            $(this).find('.imageTextTeaser.imageTextTeaser--equal-height').each((index, element) => {
                if (!$(element).find('.lazyload').length) {
                    $(this).find('.imageTextTeaser').matchHeight();
                }
            });
        });
    };

    that.setEqualHeadlineHeight = function () {
        $(document).find('.row').each(function () {
            $(this).find('.imageTextTeaser .headline-feature .content').matchHeight({ byRow: false });
        });
    };
};

window.am.teaserImageText.init();